import ServiceCard from "../components/service_components/ServiceCard";
import ServiceList from "../components/service_components/ServiceList";

const Service = () => {
    return (
        <div>
            <div>
                <ServiceList></ServiceList>
            </div>
            <div>
                <ServiceCard></ServiceCard>
            </div>
        </div>
        
    );
};

export default Service;